/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AjaxResponseOfListOfOrganizationUntiTypeDto } from '../models/ajax-response-of-list-of-organization-unti-type-dto';

@Injectable({
  providedIn: 'root',
})
export class OrganizationUnitTypesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getIdByCodeType
   */
  static readonly GetIdByCodeTypePath = '/api/services/app/OrganizationUnitTypes/GetIdByCodeType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getIdByCodeType()` instead.
   *
   * This method doesn't expect any request body.
   */
  getIdByCodeType$Response(params?: {
    CodeType?: string;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, OrganizationUnitTypesService.GetIdByCodeTypePath, 'get');
    if (params) {
      rb.query('CodeType', params.CodeType, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getIdByCodeType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getIdByCodeType(params?: {
    CodeType?: string;
  }): Observable<number> {

    return this.getIdByCodeType$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation getTypes
   */
  static readonly GetTypesPath = '/api/services/app/OrganizationUnitTypes/GetTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTypes$Response(params?: {
  }): Observable<StrictHttpResponse<AjaxResponseOfListOfOrganizationUntiTypeDto>> {

    const rb = new RequestBuilder(this.rootUrl, OrganizationUnitTypesService.GetTypesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AjaxResponseOfListOfOrganizationUntiTypeDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTypes(params?: {
  }): Observable<AjaxResponseOfListOfOrganizationUntiTypeDto> {

    return this.getTypes$Response(params).pipe(
      map((r: StrictHttpResponse<AjaxResponseOfListOfOrganizationUntiTypeDto>) => r.body as AjaxResponseOfListOfOrganizationUntiTypeDto)
    );
  }

}
